


























import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'

settings =
  name: "EnabledFeaturesList"
  components: { SuperContainerView, UiList }
  resources:
    enabledFeatures:
      resourceName: "enabled_features"
      slug: "marketplace/settings/enabled_features"
      infinityScroll: false

  vue:
    data: ->
      searchValue: ''
      searchTimeout: null

    methods:
      combinedFilters: ->
        q = @searchValue
        return { q }
      hiToggleFeature: (feature) ->
        if feature.value
          result = await @destroy("marketplace/settings/enabled_features/#{feature.name}", "enabledFeatures")
        else
          @save("marketplace/settings/enabled_features/" + feature.name, "enabled_features", {})

    watch:
      searchValue: (value) ->
        ctx = this
        window.stop()
        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.hiFilterChange()
        , 500)

export default VueOptions.vue settings
